export enum ReportEntity {
  Model = 'model',
  Comment = 'comment',
  CommentV2 = 'commentV2',
  Image = 'image',
  ResourceReview = 'resourceReview',
  Article = 'article',
  Post = 'post',
  User = 'reportedUser',
  Collection = 'collection',
  Challenge = 'challenge',
  Bounty = 'bounty',
  BountyEntry = 'bountyEntry',
  Chat = 'chat',
  ComicProject = 'comicProject',
  Model3D = 'model3d',
  Model3DReview = 'model3dReview',
}
